/** AUTO GENERATED FROM "node ./src/utils/build-icons.js". DO NOT TOUCH. * */
import React from 'react';
import classNames from 'classnames';

class Icon extends React.PureComponent {
  render() {
    const { className, svgRef, ...otherProps } = this.props;
    return (
      <svg
        width="83.39"
        height="65.09"
        viewBox="0 0 83.39 65.09"
        fill="currentColor"
        className={classNames('nmx-icon', className)}
        ref={svgRef}
        {...otherProps}>
        <path
          fill="#fff"
          d="M82.14 0H1.25A1.25 1.25 0 0 0 0 1.25v62.59a1.25 1.25 0 0 0 1.25 1.25h80.89a1.25 1.25 0 0 0 1.25-1.25V1.25A1.25 1.25 0 0 0 82.14 0Zm-1.25 2.5v60.09H2.5V2.5Z"
          className="icon-fill icon-base"/><path
          fill="#fff"
          d="M10.11 7.86a1.48 1.48 0 1 1-1.48-1.48 1.48 1.48 0 0 1 1.48 1.48"
          className="icon-fill icon-base"
          fillRule="evenodd"/><path
          fill="#fff"
          d="M17.69 7.86a1.48 1.48 0 1 1-1.48-1.48 1.48 1.48 0 0 1 1.48 1.48"
          className="icon-fill icon-base"
          fillRule="evenodd"/><path
          fill="#fff"
          d="M25.28 7.86a1.48 1.48 0 1 1-1.48-1.48 1.48 1.48 0 0 1 1.48 1.48"
          className="icon-fill icon-base"
          fillRule="evenodd"/><path
          fill="#fff"
          d="M70.31 26.98a1.002 1.002 0 0 1 .12 2H41.56a1.002 1.002 0 0 1-.12-2h28.87Z"
          className="icon-fill icon-base"/><path
          fill="#fff"
          d="M70.32 36.96a1.002 1.002 0 0 1 .11 2H34.25a1.002 1.002 0 0 1-.11-2h36.18Z"
          className="icon-fill icon-base"/><path
          fill="#fff"
          d="M70.07 46.93a1.002 1.002 0 0 1 .11 2H34a1.002 1.002 0 0 1-.11-2h36.18Z"
          className="icon-fill icon-base"/><path
          fill="#ffb81c"
          d="M17.4 24.85v2.34l-.35.07-.36.07a5.49 5.49 0 0 0-4.14 3.36 6.74 6.74 0 0 0-.48 3.14 5.36 5.36 0 0 0 2.88 4.57 22.68 22.68 0 0 0 2.41 1.08c1 .43 2 .81 3 1.24a1.83 1.83 0 0 1 1.15 2 2 2 0 0 1-1.61 2 5.43 5.43 0 0 1-1.27.14 3.17 3.17 0 0 1-3.24-2.36c-.09-.28-.16-.57-.24-.88l-3.85 1a8 8 0 0 0 1.86 3.8 6.48 6.48 0 0 0 4.22 1.95v3h2.48v-2.94c.5-.11 1-.18 1.46-.3a5.77 5.77 0 0 0 4-3.29 6.73 6.73 0 0 0 .46-4 5.29 5.29 0 0 0-2.69-3.81 30.14 30.14 0 0 0-3.68-1.61c-.75-.3-1.48-.65-2.21-1a1.59 1.59 0 0 1-.83-1 2.24 2.24 0 0 1 1.57-2.82 2.61 2.61 0 0 1 2.57.67 4.91 4.91 0 0 1 1 1.58l.25.58 3.44-1.42a6.93 6.93 0 0 0-1.26-2.59 6.13 6.13 0 0 0-4.18-2.18v-2.29Z"
          className="icon-fill icon-accent"
          fillRule="evenodd"/><path
          fill="#fff"
          d="M82.14 13.67a1.002 1.002 0 0 1 .12 2h-81a1.002 1.002 0 0 1-.12-2h81Z"
          className="icon-fill icon-base"/>
      </svg>

    );
  }
}

Icon.displayName = 'WebPageWithDollarSignIcon';

export default Icon;
